import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import moment from "moment";
import {
  Checkbox,
  DatePicker,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  TableRowColumn,
} from "material-ui";
import { tableStyles } from "../../layouts/tableStyle";
import NavigationArrowDropDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import { checkJapanese, checkMobile, debounce, showNotification } from "../../lib";
import ActionSearch from "material-ui/svg-icons/action/search";
import NotificationSystem from "react-notification-system";
let timeoutId;

const tableHeaders = [
  {
    label: "activityLogs.datetime",
    colSpan: 5,
  },
  {
    label: "activityLogs.mode",
    colSpan: 2,
  },
  {
    label: "activityLogs.room_name",
    colSpan: 3,
  },
  {
    label: "activityLogs.name",
    colSpan: 3,
  },
  {
    label: "activityLogs.event",
    colSpan: 2,
  },
  {
    label: "activityLogs.ip_address",
    colSpan: 5,
  },
];

class Header extends React.Component {
  onStartDateClick = () => {
    if (
      this.startDateCalRef &&
      this.startDateCalRef.refs &&
      this.startDateCalRef.refs.input &&
      this.startDateCalRef.refs.input.input &&
      this.startDateCalRef.refs.input.input.click
    ) {
      this.startDateCalRef.refs.input.input.click();
    }
  };

  //temp1.refs.input.input.click

  onEndDateClick = () => {
    if (
      this.endDateCalRef &&
      this.endDateCalRef.refs &&
      this.endDateCalRef.refs.input &&
      this.endDateCalRef.refs.input.input &&
      this.endDateCalRef.refs.input.input.click
    ) {
      this.endDateCalRef.refs.input.input.click();
    }
  };

  debounce = (e) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      timeoutId = null;
      this.props.onKeywordChange(e);
    }, 300);
  };

  render() {
    return (
      <div className="flex activity-logs-header mb4 mt2">
        <div className="flex activity-logs-basic-filter">
          <div className="flex flex-column items-start">
            <span style={{ fontSize: "18px", fontWeight: 'bold' }}>
              <FormattedMessage id="activityLogs.mode" />
            </span>
            <div className="flex mt2">
              <Checkbox
                className="activity-log-checkbox"
                labelStyle={{ flex: 1, marginLeft: "12px" }}
                label={<FormattedMessage id="activityLogs.conferenceMode" />}
                checked={this.props.conference}
                onCheck={(e, status) =>
                  this.props.onModeChange("conference", status)
                }
              />
              <Checkbox
                className="activity-log-checkbox"
                style={{ marginLeft: "12px" }}
                labelStyle={{
                  flex: 1,
                  minWidth: "80px",
                  marginLeft: "12px",
                  width: "unset !important",
                }}
                label={<FormattedMessage id="activityLogs.webinarMode" />}
                checked={this.props.webinar}
                onCheck={(e, status) =>
                  this.props.onModeChange("webinar", status)
                }
              />
            </div>
          </div>
          <div className="ml4 tl date-filter">
            <span style={{ fontSize: "18px", fontWeight: 'bold' }}>
              <FormattedMessage id="activityLogs.period" />
            </span>
            <div className="flex mt2">
              <span
                className="flex items-center mr2 bb shadow-hover pl1"
                onClick={this.onStartDateClick}
              >
                {this.props.startDate
                  ? this.props.startDate.format("YYYY-MM-DD")
                  : ""}
                <NavigationArrowDropDown />
                <DatePicker
                  ref={(ref) => (this.startDateCalRef = ref)}
                  value={this.props.startDate.toDate()}
                  className="activity-logs-datepicker"
                  minDate={moment(new Date()).subtract(1, "months").toDate()}
                  maxDate={moment(new Date()).toDate()}
                  onChange={(e, date) => {
                    this.props.onStartDateChange(moment(date));
                  }}
                />
              </span>
              ~
              <span
                className="flex items-center ml3 bb shadow-hover pl1"
                onClick={this.onEndDateClick}
              >
                {this.props.endDate
                  ? this.props.endDate.format("YYYY-MM-DD")
                  : ""}
                <NavigationArrowDropDown />
                <DatePicker
                  ref={(ref) => (this.endDateCalRef = ref)}
                  value={this.props.endDate.toDate()}
                  className="activity-logs-datepicker"
                  minDate={moment(new Date()).subtract(1, "months").toDate()}
                  maxDate={moment(new Date()).toDate()}
                  onChange={(e, date) => {
                    this.props.onEndDateChange(moment(date));
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="flex-auto flex items-end justify-end relative activity-log-search-container">
          <div style={{ maxWidth: "310px", flex: 1, position: 'relative' }} className="activity-log-search-wrapper">
            <ActionSearch className="activity-log-search-icon" />
            <input
              onChange={(e) => {
                this.debounce(e.target.value);
                // this.props.onKeywordChange(e);
              }}
              className="activity-log-search"
              style={{
                border: "none",
                width: "100%",
                height: "38px",
                padding: "0 5px",
                color: "#657285",
                fontSize: "14px",
                border: "1.5px solid",
                maxWidth: "300px",
              }}
              placeholder={
                checkJapanese()
                  ? "部屋名・参加者を検索する"
                  : "Search for room names/participants"
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

class ActivityLogsTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      webinar: true,
      conference: true,
      startDate: moment(new Date()).subtract(1, "months"),
      endDate: moment(new Date()),
      keyword: "",
    };
  }

  onStartDateChange = (startDate) => {
    if(this.areDatesInvalid(startDate, this.state.endDate)) {
      this.showErrorNotification(<FormattedMessage id="activityLogs.selectValidDate" />)
    }

    this.setState({ startDate }, this.filterLogs);
  };

  onEndDateChange = (endDate) => {
    if(this.areDatesInvalid(this.state.startDate, endDate)) {
      this.showErrorNotification(<FormattedMessage id="activityLogs.selectValidDate" />)
    }

    this.setState({ endDate }, this.filterLogs);
  };

  showErrorNotification = (message) => {
    showNotification(this.refs.notificationSystem, message, 'error', 10);
  } 

  areDatesInvalid = (startDate, endDate) => {
    return endDate.isBefore(startDate);
  }

  filterLogs = () => {
    this.props.filterLogs(
      this.state.conference,
      this.state.webinar,
      this.state.startDate.clone(),
      this.state.endDate.clone().add('day', 1),
      this.state.keyword
    );
  };

  onKeywordChange = (keyword) => {
    this.setState({ keyword }, this.filterLogs);
  };

  onModeChange = (type, status) => {
    if (this.props.activityLogs.length === 0) {
      return;
    }

    if((type === 'conference' && !this.state.webinar) || (type === 'webinar' && !this.state.conference)) {
      this,this.showErrorNotification(<FormattedMessage id="activityLogs.selectMode" />)
      return;
    }

    if (type === "conference") {
      this.setState({ conference: status }, this.filterLogs);
    } else {
      this.setState({ webinar: status }, this.filterLogs);
    }
  };



  render() {
    const { intl } = this.props;
    // const activityLogs = this.props.activityLogs.filter(l => l.show);
    return (
      <div>
        <div className="activity-log-notification">
          <NotificationSystem ref="notificationSystem" />
        </div>
        <Header
          webinar={this.state.webinar}
          conference={this.state.conference}
          onStartDateChange={this.onStartDateChange}
          onEndDateChange={this.onEndDateChange}
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onModeChange={this.onModeChange}
          onKeywordChange={this.onKeywordChange}
        />
        <div className="table-wrapper mt3 activity-log-table">
          <Table
            selectable={false}
            fixedHeader={true}
            height="65vh"
            style={{
              ...tableStyles.table,
              minWidth: checkMobile() ? "900px" : "650px",
            }}
          >
            <TableHeader
              displaySelectAll={false}
              enableSelectAll={false}
              adjustForCheckbox={false}
            >
              <TableRow style={tableStyles.tableHeaderRow}>
                {tableHeaders.map((header) => {
                  return (
                    <TableRowColumn
                      colSpan={header.colSpan}
                      style={{ ...tableStyles.tableData, color: "#fff" }}
                    >
                      <FormattedMessage id={header.label} />
                    </TableRowColumn>
                  );
                })}
              </TableRow>
            </TableHeader>

            <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
              {(this.props.isFetchingList ||
                (!this.props.isFetchingList &&
                  this.props.activityLogs.filter((l) => l.show).length ===
                    0)) && (
                <TableRow
                  selected={false}
                  className="light-row"
                  style={tableStyles.tableBodyRow}
                >
                  <TableRowColumn colSpan={20} style={tableStyles.tableData}>
                    <FormattedMessage
                      id={
                        this.props.isFetchingList
                          ? "login.fetching"
                          : "activityLogs.noLogs"
                      }
                    />
                  </TableRowColumn>
                </TableRow>
              )}

              {this.props.activityLogs
                .filter((l) => l.show)
                .map((activityLog, index) => {
                  return (
                    <TableRow
                      key={index}
                      selected={false}
                      className={index % 2 == 0 ? "dark-row" : "light-row"}
                      style={tableStyles.tableBodyRow}
                    >
                      <TableRowColumn colSpan={5} style={tableStyles.tableData}>
                        {moment(activityLog.datetime).format(
                          "YYYY-MM-DD HH:mm:ss"
                        )}
                      </TableRowColumn>
                      <TableRowColumn colSpan={2} style={tableStyles.tableData}>
                        {activityLog.is_webinar ? (
                          <FormattedMessage id="activityLogs.webinar" />
                        ) : (
                          <FormattedMessage id="activityLogs.conference" />
                        )}
                      </TableRowColumn>
                      <TableRowColumn colSpan={3} style={tableStyles.tableData}>
                        {activityLog.room_name}
                      </TableRowColumn>
                      <TableRowColumn colSpan={3} style={tableStyles.tableData}>
                        {activityLog.name}
                      </TableRowColumn>
                      <TableRowColumn colSpan={2} style={tableStyles.tableData}>
                        {activityLog.event === "join" ? (
                          <FormattedMessage id="activityLogs.join_event" />
                        ) : (
                          <FormattedMessage id="activityLogs.leave_event" />
                        )}
                      </TableRowColumn>
                      <TableRowColumn colSpan={5} style={tableStyles.tableData}>
                        {activityLog.ip_address}
                      </TableRowColumn>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
      </div>
    );
  }
}

export default injectIntl(ActivityLogsTable);



// WEBPACK FOOTER //
// src/components/ActivityLogsTable/Table.js